import type { StepPanelPassThroughOptions } from "primevue/steppanel";

export const steppanel: StepPanelPassThroughOptions = {};
